var exports = {
  "I": "summaryContainer__caZ0zu",
};

module.exports = exports;
